import { Disclosure } from '@headlessui/react'
import { ReactComponent as ArrowDownIcon } from 'src/assets/icons/arrow-down.svg'
import { ReactComponent as ArrowUpIcon } from 'src/assets/icons/arrow-up.svg'
import React from 'react'

export const LinkCard: React.FC<{ iconLeft?: React.ReactNode, title?: string, subTitle?: string, card: any }> = props => {
  const { title, subTitle, iconLeft, card } = props

  console.log('card', card)
  return (
    <div className="w-[376px] box-border">
      <div className="w-full max-w-md rounded-lg bg-[#171B21]">
        <Disclosure>
          {({ open }) => (
            <>
              <Disclosure.Button className="flex w-full justify-between rounded-lg px-4 py-3 text-left text-sm font-medium text-white border-2 border-[#2B2D31] hover:ring-2 ring-[#826AED] focus:outline-none   ">
              <div className={'flex gap-2'}>
                  {iconLeft && iconLeft}
                  <div className={'flex gap-0.5 flex-col'} >
                  <span className={'text-sm'}>{title}</span>
                    {subTitle && <span className={'text-xs text-[#7E858F]'}>Subtitle</span>}
                </div></div>
                { open
                  ? <ArrowUpIcon className={'mt-[4px]'} />
                  : <ArrowDownIcon className={'mt-[4px]'} />
                }
              </Disclosure.Button>
              <Disclosure.Panel className="px-4 pt-6 text-sm">
               <div className={'flex text-white justify-between text-xs p-[8px] rounded-t-lg border-2 border-[#2B2D31]'}>
                 <span className={'font-bold'}>Path</span>
                 <span>{card.path}</span>
               </div>
              </Disclosure.Panel>
              <Disclosure.Panel className="px-4  text-sm ">
                <div className={'flex text-white justify-between text-xs p-[8px] border-2 border-[#2B2D31]'}>
                  <span className={'font-bold'}>Type</span>
                  <span>{card.type}</span>
                </div>
              </Disclosure.Panel>
              <Disclosure.Panel className="px-4 pb-6 text-sm ">
                <div className={'flex text-white justify-between text-xs p-[8px] rounded-b-lg border-2 border-[#2B2D31]'}>
                  <span className={'font-bold'}>Auth</span>
                  <span>{card?.auth?.name}</span>
                </div>
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      </div>
    </div>
  )
}
